import script from "./Program.vue?vue&type=script&setup=true&lang=js"
export * from "./Program.vue?vue&type=script&setup=true&lang=js"

import "./Program.vue?vue&type=style&index=0&id=26b0e50c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b0e50c"]])

export default __exports__